import styled from "styled-components/macro";
import { focusOutline } from "../../styles/a11y";

export const StyledContainer = styled.div`
  position: relative;
  display: block;
  width: 40px;
  height: 20px;
  margin-right: 10px;

  &.display-only {
    pointer-events: none;
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--menu-color-active);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: -1px;
    bottom: -1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  }

  input:focus-visible + .slider {
    ${focusOutline}
  }

  input:checked + .slider {
    background-color: var(--primary-cta-high-contrast);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
    background-color: white;
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;
